import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../magic_forms_2/store/hooks";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { ReactComponent as Contact } from "../assets/contact.svg";
import { ReactComponent as Phone } from "../assets/phone.svg";
import { ReactComponent as Place } from "../assets/place.svg";
import { ReactComponent as Mail } from "../assets/email.svg";
import {
  getAsesorBrandConfig,
  getAsesorInfo,
  getAsesorPic,
  resetAsesorDirectory,
  selectAsesor,
  selectAsesorPic,
  selectAsesorPicLoading,
  selectBrandConfig,
  selectLoadingAsesor,
  selectLoadingBrandConfig,
} from "./asesorSlice";
import { getFlujoAsesor } from "../hyperFlow/hyperFlowApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ShowData } from "./components/ShowData";
import "./asesorStyle.css";
import { useHistory } from "react-router-dom";

export const AsesorCard = () => {
  const asesor = useAppSelector(selectAsesor);
  const brandConfig = useAppSelector(selectBrandConfig);
  const loadingInfo = useAppSelector(selectLoadingAsesor);
  const loadingPic = useAppSelector(selectAsesorPicLoading);
  const loadingBrandConfig = useAppSelector(selectLoadingBrandConfig);
  const picBase64 = useAppSelector(selectAsesorPic);

  const dispatch = useAppDispatch();
  const history = useHistory();

  const query = useQuery();
  const idAsesor = query.get("idAsesor") ?? "error";
  const [loadingButton, setLoadingButton] = useState(false);

  const getInitialsFromName = (fullName: string) => {
    if (!fullName) return "";

    const ignored = new Set([
      "de",
      "del",
      "la",
      "las",
      "los",
      "da",
      "do",
      "dos",
      "das",
    ]);

    const parts = fullName
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter((p) => p && !ignored.has(p));

    if (parts.length === 0) return "";

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    const first = parts[0][0];
    const last = parts[parts.length - 1][0];

    return (first + last).toUpperCase();
  };

  const onlyCapitalizeName = (fullName: string) => {
    if (!fullName) return "";

    const lowercaseWords = new Set([
      "de",
      "del",
      "la",
      "las",
      "los",
      "da",
      "do",
      "dos",
      "das",
    ]);

    return fullName
      .toLowerCase()
      .split(/\s+/)
      .map((word, index) => {
        if (lowercaseWords.has(word) && index !== 0) {
          return word; // keep connectors lowercase (except if first word)
        }

        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const capitalizeFirstLetter = (str: string) => {
    //capitalize first letter of each word but if its all caps put it in lowercase first
    return str
      .split(" ")
      .map((word) => (word === word.toUpperCase() ? word.toLowerCase() : word))
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getfieldToShowById = (id: string) => {
    const field = asesor.asesorData.fieldsToShow?.find((f) => f.id === id);
    if (field) {
      return field.value;
    } else return "";
  };
  const redirectButton = () => {
    if (
      asesor.asesorData.hyperFlowConfigs &&
      asesor.asesorData.hyperFlowConfigs.length > 0
    ) {
      if (
        asesor.asesorData.hyperFlowConfigs.length === 1 &&
        asesor.asesorData.hyperFlowConfigs[0]
      ) {
        return (
          <button
            onClick={async (e) => {
              e.preventDefault();
              setLoadingButton(true);
              await getFlujoAsesor(
                idAsesor,
                asesor.asesorData.hyperFlowConfigs![0].hyperFlowId
              );
              setLoadingButton(false);
            }}
            style={{
              border: "none",
              background:
                brandConfig.primaryButtonColor ??
                "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
              borderRadius: "30px",
              color:
                brandConfig.primaryTextColor ??
                brandConfig.secondaryMessageColor ??
                "white",
              fontSize: "20px",
              textTransform: "uppercase",
              fontWeight: 600,
              fontFamily: "Open Sans",
              margin: "20px 0 30px 0",
              padding: "10px 50px",
              cursor: "pointer",
            }}
          >
            {loadingButton ? (
              <ClipLoader color={brandConfig.primaryTextColor} size={20} />
            ) : (
              asesor.asesorData.hyperFlowConfigs[0].buttonText ?? "Vincúlate"
            )}
          </button>
        );
      } else {
        return (
          <button
            onClick={(e) => {
              e.preventDefault();
              history.push(`/asesorDetail?idAsesor=${idAsesor}`);
            }}
            style={{
              border: "none",
              background:
                brandConfig.primaryButtonColor ??
                "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
              borderRadius: "30px",
              color:
                brandConfig.primaryTextColor ??
                brandConfig.secondaryMessageColor ??
                "white",
              fontSize: "20px",
              textTransform: "uppercase",
              fontWeight: 600,
              fontFamily: "Open Sans",
              margin: "20px 0 30px 0",
              padding: "10px 50px",
              cursor: "pointer",
            }}
          >
            Conoce más
          </button>
        );
      }
    } else {
      return (
        <button
          onClick={async (e) => {
            setLoadingButton(true);
            e.preventDefault();
            await getFlujoAsesor(idAsesor);
            setLoadingButton(false);
          }}
          style={{
            border: "none",
            background:
              brandConfig.primaryButtonColor ??
              "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
            borderRadius: "30px",
            color:
              brandConfig.primaryTextColor ??
              brandConfig.secondaryMessageColor ??
              "white",
            fontSize: "20px",
            textTransform: "uppercase",
            fontWeight: 600,
            fontFamily: "Open Sans",
            margin: "20px 0 30px 0",
            padding: "10px 50px",
            cursor: "pointer",
          }}
        >
          {loadingButton ? (
            <ClipLoader color={brandConfig.primaryTextColor} size={20} />
          ) : (
            "Vincúlate"
          )}
        </button>
      );
    }
  };

  const coomuldesaV2Render = () => {
    return (
      <div
        style={{
          fontFamily: "Open Sans",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: "500px",
          minHeight: "100vh",
          overflow: "auto",
        }}
      >
        {" "}
        <img
          alt="Logo de la empresa"
          src={brandConfig.logoUrl!!}
          style={{
            maxWidth: "120px",
            maxHeight: "90px",
            width: "auto",
            height: "auto",
            margin: "13% 0 10% 0",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            margin: "30px 0",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              borderRadius: "10px",
              background: "#A6D5D1",
              height: "35px",
              width: "34px",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "#354C5D",
              fontSize: "15px",
              fontWeight: 700,
            }}
          >
            {getInitialsFromName(asesor.name)}
          </div>
          <div
            style={{
              marginLeft: "5px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                color: brandConfig.primaryTextColor,
                fontWeight: 700,
                maxWidth: "270px",
                textAlign: "start",
                margin: "0",
              }}
            >
              {onlyCapitalizeName(asesor.name)}
            </h3>
            <p
              style={{
                fontSize: "12px",
                color: brandConfig.primaryTextColor,
                fontWeight: 600,
                maxWidth: "270px",
                textAlign: "start",
                margin: "0",
              }}
            >
              {capitalizeFirstLetter(getfieldToShowById("cargo"))}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "3px",
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  color: brandConfig.primaryTextColor,
                  fontWeight: 600,
                  textAlign: "start",
                  margin: "0",
                }}
              >
                📞 {getfieldToShowById("phone")}
              </p>
              <p
                style={{
                  fontSize: "12px",
                  color: brandConfig.primaryTextColor,
                  fontWeight: 600,
                  textAlign: "start",
                  margin: "0 0 0 15px",
                  maxWidth: "200px",
                }}
              >
                📍{getfieldToShowById("dirección")}
              </p>
            </div>
          </div>
        </div>
        <h4
          style={{
            color: brandConfig.primaryTextColor,
            fontSize: "15px",
            fontWeight: 700,
            textAlign: "start",
            marginLeft: "5%",
            marginBottom: "10px",
            alignSelf: "start",
          }}
        >
          ¿Que quieres hacer hoy?
        </h4>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "1em",
            width: "80%",
          }}
        >
          {asesor.asesorData.hyperFlowConfigs &&
            asesor.asesorData.hyperFlowConfigs.map((hyperFlowConfig) => (
              <div
                key={hyperFlowConfig.hyperFlowId}
                style={{
                  color:
                    brandConfig.primaryTextColor ??
                    "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
                  margin: "15px 0",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    borderRadius: "10px",
                    background: "#A6D5D1",
                    height: "35px",
                    width: "34px",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "#354C5D",
                    fontSize: "21px",
                    fontWeight: 700,
                  }}
                >
                  {hyperFlowConfig.emojiText}
                </div>
                <h3
                  style={{
                    margin: "0",
                    fontWeight: 700,
                    fontSize: "20px",
                    color: brandConfig.primaryTextColor,
                  }}
                >
                  {hyperFlowConfig.title}
                </h3>
                <p
                  style={{
                    margin: "0",
                    fontWeight: 600,
                    fontSize: "12px",
                    lineHeight: "18px",
                    color: brandConfig.primaryTextColor,
                    textAlign: "start",
                  }}
                >
                  {hyperFlowConfig.description}
                </p>
                <button
                  disabled={loadingButton}
                  style={{
                    width: "100%",
                    borderRadius: "15px",
                    border: "none",
                    background: "#116049",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "50px",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: 600,
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                  onClick={async (e) => {
                    e.preventDefault();
                    setLoadingButton(true);
                    await getFlujoAsesor(idAsesor, hyperFlowConfig.hyperFlowId);
                    setLoadingButton(false);
                  }}
                >
                  {loadingButton ? (
                    <ClipLoader color={"#fff"} size={20} />
                  ) : (
                    hyperFlowConfig.buttonText || "Empezar"
                  )}
                </button>
              </div>
            ))}
        </div>
      </div>
    );
  };

  const infoRender = () => {
    let asesorDataSorted = [...(asesor.asesorData.fieldsToShow || [])];
    asesorDataSorted = asesorDataSorted.sort((a, b) => {
      return a.showingOrder - b.showingOrder;
    });
    if (asesorDataSorted && asesorDataSorted.length > 0) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          {asesorDataSorted.map((field) => {
            return (
              <ShowData
                label={field.label || "Elemento"}
                value={field.value!}
                primaryColor={brandConfig.primaryTextColor!}
                canCopy={field.canCopy}
                iconId={field.iconId}
                key={field.id!}
                phonePrefix={field.phonePrefix}
                toast={toast}
              />
            );
          })}
        </div>
      );
    } else {
      return (
        <>
          {asesor.asesorData.cargo && (
            <p
              style={{
                fontSize: "12px",
                fontWeight: 800,
                textAlign: "center",
                color: brandConfig.primaryTextColor,
                textTransform: "uppercase",
                margin: 0,
              }}
            >
              {asesor.asesorData.cargo}
            </p>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            {asesor.name && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "21px 0 21px 0",
                }}
              >
                <Contact
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={30}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  {" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.name}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.identification}
                  </p>
                </div>
              </div>
            )}
            {asesor.phoneNumber && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 18px 0",
                }}
              >
                <Phone
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={25}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    <a
                      style={{ color: "inherit", textDecoration: "none" }}
                      href={`tel:+57${asesor.phoneNumber}`}
                    >
                      {asesor.phoneNumber}
                    </a>
                  </p>{" "}
                </div>
              </div>
            )}
            {asesor.email && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 21px -2px",
                }}
              >
                <Mail
                  color={brandConfig.primaryTextColor}
                  width={25}
                  height={25}
                  style={{ marginLeft: "3px" }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    <a
                      style={{ color: "inherit", textDecoration: "none" }}
                      href={`mailto:${asesor.email}`}
                    >
                      {asesor.email}
                    </a>
                  </p>{" "}
                </div>
              </div>
            )}
            {asesor.asesorData.direccion && asesor.asesorData.oficina && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 0 21px 0",
                }}
              >
                <Place
                  style={{ margin: "0 0 0 -3px" }}
                  color={brandConfig.primaryTextColor}
                  width={30}
                  height={25}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                    margin: "0 0 0 18px",
                  }}
                >
                  {" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {asesor.asesorData.direccion}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      color: brandConfig.primaryTextColor,
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    Oficina {asesor.asesorData.oficina}
                  </p>
                </div>
              </div>
            )}
          </div>
          {asesor.asesorData.codAsesor && (
            <div
              onClick={() => {
                navigator.clipboard.writeText(asesor.asesorData.codAsesor);
                toast.success("Código copiado al portapapeles", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              }}
              style={{
                width: "211px",
                height: "28px",
                padding: "7px 0 7px 0",
                fontSize: "16px",
                fontWeight: 600,
                textAlign: "center",
                color: brandConfig.primaryTextColor,
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "8px",
                outline: "none",
                position: "relative",
                margin: "10px 0 20px 0",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-12px",
                  left: "-30px",
                  right: "0",
                  textTransform: "uppercase",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: brandConfig.primaryTextColor,
                }}
              >
                Código referencia
              </div>
              <p
                style={{
                  margin: "5px 0 0 0",
                  textAlign: "center",
                  position: "relative",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: brandConfig.primaryTextColor,
                }}
              >
                {asesor.asesorData.codAsesor}
              </p>
            </div>
          )}
        </>
      );
    }
  };

  const content = () => {
    if (loadingInfo === "pending" || loadingBrandConfig === "pending") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <ClipLoader color={brandConfig.primaryTextColor} size={120} />;
          <h5
            style={{
              color: brandConfig.primaryTextColor,
              marginTop: "20px",
              fontSize: "20px",
            }}
          >
            Obteniendo información
          </h5>
        </div>
      );
    } else if (loadingInfo === "resolved") {
      if (asesor.asesorData.version === "coomuldesaV2") {
        return coomuldesaV2Render();
      } else {
        return (
          <div
            style={{
              fontFamily: "Open Sans",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              alt="Logo de la empresa"
              src={brandConfig.logoUrl!!}
              style={{
                maxWidth: "200px",
                maxHeight: "320px",
                width: "auto",
                height: "auto",
                margin: "10px 0 10px 0",
              }}
            />

            <div
              style={{
                maxWidth: "190px",
                maxHeight: "270px",
                margin: "20px 0 0 0",
              }}
            >
              {loadingPic === "pending" ? (
                <ClipLoader color={brandConfig.primaryTextColor} size={40} />
              ) : (
                <img
                  alt="Imagen del asesor"
                  src={`data:image/png;base64, ${picBase64}`}
                  style={{
                    maxWidth: "190px",
                    maxHeight: "270px",
                    objectFit: "cover",
                    borderRadius: "30px",
                  }}
                />
              )}
            </div>
            {infoRender()}
            {redirectButton()}
          </div>
        );
      }
    } else if (
      (loadingInfo === "idle" && idAsesor === "error") ||
      loadingInfo === "rejected"
    ) {
      return (
        <div
          style={{
            background: `linear-gradient(180deg, ${brandConfig.backgroundColor1}, ${brandConfig.backgroundColor2})`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <h5
              style={{
                color: brandConfig.primaryTextColor,
                marginTop: "20px",
                fontSize: "20px",
              }}
            >
              Asesor no encontrado
            </h5>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: `linear-gradient(180deg, ${brandConfig.backgroundColor1}, ${brandConfig.backgroundColor2})`,
          }}
        >
          {" "}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <h5
              style={{
                color: brandConfig.primaryTextColor,
                marginTop: "20px",
                fontSize: "20px",
              }}
            >
              Asesor no encontrado
            </h5>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    dispatch(resetAsesorDirectory());
    if (loadingInfo === "idle" && idAsesor !== "error") {
      dispatch(getAsesorInfo(idAsesor));
    }

    if (loadingPic === "idle" && idAsesor !== "error") {
      dispatch(getAsesorPic(idAsesor));
    }

    if (loadingBrandConfig === "idle" && idAsesor !== "error") {
      dispatch(getAsesorBrandConfig(idAsesor));
    }
    return () => {};
  }, [idAsesor, dispatch, loadingInfo, loadingBrandConfig, loadingPic]);

  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        overflow: "auto",
        alignItems: "center",
        background: `linear-gradient(180deg, ${brandConfig.backgroundColor1} , ${brandConfig.backgroundColor2})`,
      }}
    >
      {content()}
      <ToastContainer />
    </div>
  );
};
